<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-07-10 10:17:12
 * @最后编辑: Betway
 * @最后修改时间: 2022-08-08 11:39:50
 * @FilePath: \mrc-base-frontend\src\components\mrc_ess_searchInput.vue
--> 
<template>
  <div class="v-responsive mr-auto transition-swing flex-grow-1">
    <div class="v-responsive__content" style="width: 100%">
      <div
        class="
          v-input v-input--hide-details v-input--dense
          theme--light
          v-text-field
          v-text-field--single-line
          v-text-field--solo
          v-text-field--solo-flat
          v-text-field--enclosed
          v-text-field--rounded
        "
      >
        <div class="v-input__control">
          <div class="v-input__slot grey lighten-3">
            <div v-if="isShow" class="v-input__prepend-inner">
              <div class="v-input__icon v-input__icon--prepend-inner">
                <i
                  aria-hidden="true"
                  @click="search"
                  class="v-icon notranslate mdi mdi-magnify theme--light"
                ></i>
              </div>
            </div>
            <div class="v-text-field__slot">
              <!-- <label for="doc-search"
                       class="v-label theme--light"
                       style="left:0px;right:auto;position:absolute;">
                </label> -->
              <!-- <input id="doc-search"
                       type="text"
                       @keydown='keydown'
                       @input="input"
                       @change="change"
                       v-model="value"> -->
              <input
                type="text"
                @keydown="keydown"
                @input="input"
                @change="change"
                v-model="value"
              />
            </div>
            <div v-if="isShow" @click="search" class="v-input__append-outer">
              <div
                class="v-input__icon v-input__icon--append-outer"
                v-if="appendShow"
              >
                <mrc_ess_svgIcon icon-class="service" style="font-size: 30px" />
              </div>
            </div>
            <div v-if="!isShow" @click="search" class="v-input__append-outer">
              <div class="v-input__icon v-input__icon--append-outer">
                <i
                  aria-hidden="true"
                  class="v-icon notranslate mdi mdi-magnify theme--light"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*
        <mrc_ess_searchInput v-model='searchValue'
                             @search='search'
                             @keydown='keydown'></mrc_ess_searchInput>
*/
export default {
  components: {},
  props: {
    appendShow: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
    },
    prependIcon: {
      type: String,
    },
    searchValue: {
      type: String,
      default: "Search Hints",
    },
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "searchValue",
    event: "change",
  },
  data() {
    return {
      value: "",
    };
  },
  computed: {},
  created() {},
  watch: {},
  mounted() {
    this.value = this.searchValue;
  },

  methods: {
    change() {
      this.$emit("change", this.value);
    },
    input() {
      this.$emit("input", this.value);
    },
    search(e) {
      this.$emit("change", this.value);
      this.$emit("search", this.value);
    },
    keydown(event) {
      //回车事件
      if (event.keyCode == 13) {
        this.$emit("change", this.value);
        this.$emit("keydown", this.value);
      }
    },
  },
};
</script> 

<style scoped>
</style>
